import React, { useState, useRef } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { useSelector } from "react-redux";
import { ImSpinner2 } from "react-icons/im";
import { formatFieldValue } from "../SideBar/Results/Identify/FeatureDescription";

const initialDataState = {
    filter: undefined,
    sort: undefined,
};

const DataLinksGrid = ({ dataLinkConfig, filterOn }) => {
    const [dataState, setDataState] = useState(initialDataState);
    const dataLinkData = useSelector((state) => state.resultsData.dataLinkData);
    const dataLinkId = dataLinkConfig.DataLinkID;
    const data =
        // If empty object
        Object.keys(dataLinkData).length === 0
            ? "Loading"
            : dataLinkData.data === undefined
            ? "No Related Records"
            : formatDataLinkGridData(dataLinkData.data[dataLinkId]);

    const filterChange = (e) => {
        setDataState({ ...dataState, filter: e.filter });
    };

    const handleDataChange = (e) => {
        setDataState(e.dataState);
    };

    return (
        <>
            {data === "Loading" ? (
                <ImSpinner2 className="grid-spinner" />
            ) : data === "No Data" || data === undefined ? (
                <div>Error fetching data</div>
            ) : data.length === 0 ? (
                <i>No Related Records</i>
            ) : (
                <Grid
                    data={process(data, {
                        filter: dataState.filter,
                        sort: dataState.sort,
                    })}
                    style={{ position: "absolute" }}
                    // Filter
                    onFilterChange={filterChange}
                    filterable={filterOn}
                    filter={dataState.filter}
                    // Sort
                    sortable={true}
                    sort={dataState.sort}
                    resizable={true}
                    onDataStateChange={handleDataChange}>
                    {Object.keys(data[0]).map((key) => {
                        return (
                            <GridColumn
                                title={key}
                                field={key}
                                resizable={true}
                                editor="text"
                                width="120px"
                                key={key}
                            />
                        );
                    })}
                </Grid>
            )}
        </>
    );
};

export default DataLinksGrid;

/**
 * Passes datlink object through formatFieldFunction
 * @fires formatFieldFunction
 * @param {Object} dataLinks DataLink Object return from API
 * @returns {Object} Formatted object
 */
export const formatDataLinkGridData = (dataLinks) => {
    const newDataLinks = dataLinks.map((dataLink) => {
        const newGridObj = {};
        Object.keys(dataLink).forEach((key) => {
            const newVal = formatFieldValue({ Name: key }, dataLink);
            Object.assign(newGridObj, { [key]: newVal });
        });
        return newGridObj;
    });
    return newDataLinks;
};
